const COLORS = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  GREEN: '#d6f0e0',
  BUTTON_GREEN: '#139c49',
  DARK_GREEN: '#008751',
  DARK_GREEN_HOVER: '#00a768',
  TEXT: '#1B242A',
  TEXT_DISABLED: '#181818',
  GRAY: '#96999c',
  HOVER_BACKGROUND_AUTOCOMPLETE: 'rgba(0, 0, 0, 0.04)',
  DISABLED_BACKGROUND_AUTOCOMPLETE: 'rgb(240, 240, 240)',
  DISABLED_BORDER_AUTOCOMPLETE: '#ababab',
  BORDER_AUTOCOMPLETE: '#c4c4c4',
  BORDER_ERROR_TEXTFIELD: '#d32f2f',
  BORDER_TEXTFIELD: 'rgba(0, 0, 0, 0.23)',
  LIGHT_GREY: '#e0e0e0',
  GREY: '#f4f4f4',
  SELECT_LABEL_GREEN: '#d8e8d5',
  SELECTED_OPTION_BACKGROUND: '#d8e8d5',
  BC_GREEN: '#69BE28',
  BC_DARK_GREEN: '#3c8a23',
  BC_RED: '#d80c11',
  BC_YELLOW: '#f1c308',
  ORANGE: '#f68932',
  STATUS_DISABLE: '#D11414',
  STATUS_ACTIVE: '#0BC94B'
};

export default COLORS;
